import React, { createContext, useContext, useEffect } from 'react';

import { useStoredState } from '../hooks/use-stored-state';
import { isValidId } from '../utils/secure-storage';

type SessionContext = {
    id: string;
};

/**
 * Hook
 * */
const SessionContext = createContext<SessionContext|null>(null);

export function useSession() {
    return useContext(SessionContext) as SessionContext;
}

/**
 * Provider
 * */
export function SessionProvider(props: { children: React.ReactNode }) {
    const [id, setId, isLoaded] = useStoredState('chat.session', '');

    useEffect(() => {
        if(!isLoaded) return;

        if(!id || !isValidId(id)) {
            setId(generateSessionId());
        }
    }, [id, isLoaded]);

    if(!isLoaded || !id) {
        return null;
    }

    return <SessionContext.Provider value={{ id }}>
        {props.children}
    </SessionContext.Provider>;
}

function generateSessionId(): string {
    const arr = new Uint8Array(16);
    let hex = '';

    window.crypto.getRandomValues(arr);

    for(let i = 0; i < arr.length; i++) {
        hex += ('0' + arr[i].toString(16)).slice(-2);
    }

    return hex;
}
